import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './BackToTop.css';

export default class BackToTop extends Component {
  static propTypes = {
    className: PropTypes.string,
    scrollStepInPx: PropTypes.string.isRequired,
    delayInMs: PropTypes.string.isRequired,
  }

  static defaultProps = {
    className: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
    };
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop = () => {
    const intervalId = setInterval(this.scrollStep, this.props.delayInMs);
    this.setState({ intervalId });
  }
  render() {
    return (
      <div className="BackToTop hidePrint">
        <button className={`backTop ${this.props.className}`} onClick={this.scrollToTop}>
          <span className="arrow" />
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BackToTop.jsx